import PropTypes from "prop-types";
import React from "react";

import DuplicateDestinationForm from "v2/components/responsive/DuplicateDestinationForm";
import ModalLink from "v2/components/responsive/ModalLink";

const DeleteDestinationLink = (props, context) => {
  const {params: {date, id, routeId}} = context;
  return (
    <ModalLink
      form={DuplicateDestinationForm}
      label="Duplicate"
      url={`/${date}/${routeId}/${id}/duplicate`}
      {...props} />
  );
};

DeleteDestinationLink.contextTypes = {
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
};

export default DeleteDestinationLink;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/DuplicateDestinationLink.js
 **/